function fnAccordionAlt(i, oSection) {
  const items = oSection.querySelectorAll(".item");

  items.length &&
    items.forEach((el) => {
      el.querySelector(".label").addEventListener("click", () => {
          items.forEach((siblingsEl) => {
            if (siblingsEl === el && el.ariaCurrent != "true") {
              gsap.set(el.querySelector(".text"), {
                display: "block",
              });
              gsap.from(el.querySelector(".text"), {
                height: 0,
                paddingTop: 0,
              });

              el.ariaCurrent = true;
            } else {
              gsap.to(siblingsEl.querySelector(".text"), {
                display: "none",
                height: 0,
                paddingTop: 0,
                clearProps: "all",
              });

              siblingsEl.ariaCurrent = false;
            }
          });
      });
    });
}
